import {useCallback, ReactElement} from 'react';
import {Image as ImageType} from '@shopify/hydrogen/storefront-api-types';
import EditProductReviewModal from './EditProductReviewModal.client';
import {MemberProductType} from '../../types/backend';
import {useMemberProduct} from '../../contexts/MemberProductProvider.client';

interface ProductDetailProductReviewModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  shopifyProductId: string;
  productTitle: string;
  productImage: ImageType;
}

export default function ProductDetailProductReviewModal({
  isOpen,
  onRequestClose,
  shopifyProductId,
  productTitle,
  productImage,
}: ProductDetailProductReviewModalProps): ReactElement {
  const {setMyMemberProduct} = useMemberProduct();

  const updateMemberProduct = useCallback(
    (memberProduct: MemberProductType) => setMyMemberProduct(memberProduct),
    [setMyMemberProduct],
  );

  return (
    <EditProductReviewModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shopifyProductId={shopifyProductId}
      productTitle={productTitle}
      productImage={productImage}
      onSuccess={updateMemberProduct}
    />
  );
}
